
import Index from "./Index.vue";
import SerialStart from "./SerialStart.vue";
import SerialConfirm from "./SerialConfirm.vue";
import SerialEnd from "./SerialEnd.vue";
import SerialMail from "./SerialMail.vue";
import RegistrationStart from "./RegistrationStart.vue";
import RegistrationConfirm from "./RegistrationConfirm.vue";
import Order from "./Order.vue";
import OrderConfirm from "./OrderConfirm.vue";
import Delivery from "./Delivery.vue";
import DeliveryConfirm from "./DeliveryConfirm.vue";
import DeliveryEnd from "./DeliveryEnd.vue";
import DeliveryMail from "./DeliveryMail.vue";

export default {
  routes: [
    {
      path: "/mock/shopping",
      component: Index,
    },
    {
      path: "/mock/shopping/serial",
      component: SerialStart,
    },
    {
      path: "/mock/shopping/serial/confirm",
      component: SerialConfirm,
    },
    {
      path: "/mock/shopping/serial/end",
      component: SerialEnd,
    },
    {
      path: "/mock/shopping/serial/mail",
      component: SerialMail,
    },
    {
      path: "/mock/shopping/registration",
      component: RegistrationStart,
    },
    {
      path: "/mock/shopping/registration/confirm",
      component: RegistrationConfirm,
    },
    {
      path: "/mock/shopping/order",
      component: Order,
    },
    {
      path: "/mock/shopping/order/confirm",
      component: OrderConfirm,
    },
    {
      path: "/mock/shopping/delivery",
      component: Delivery,
    },
    {
      path: "/mock/shopping/delivery/confirm",
      component: DeliveryConfirm,
    },
    {
      path: "/mock/shopping/delivery/end",
      component: DeliveryEnd,
    },
    {
      path: "/mock/shopping/delivery/mail",
      component: DeliveryMail,
    },
  ],
};
